import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import ContactForm from "@/components/ContactForm";

const OVERLAY_INITIAL = { opacity: 0 };
const OVERLAY_ANIMATE = { opacity: 1 };
const OVERLAY_TRANSITION = { duration: 0.3 };
const PANEL_INITIAL = { y: 60, opacity: 0, scale: 0.96 };
const PANEL_ANIMATE = { y: 0, opacity: 1, scale: 1 };
const PANEL_EXIT = { y: 40, opacity: 0, scale: 0.97 };
const PANEL_TRANSITION = { duration: 0.5, ease: [0.16, 1, 0.3, 1] };

export default function ContactModal({ open, onClose }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="contact-modal"
          className="fixed inset-0 z-[80] flex items-center justify-center px-5"
          initial={OVERLAY_INITIAL}
          animate={OVERLAY_ANIMATE}
          exit={OVERLAY_INITIAL}
          transition={OVERLAY_TRANSITION}
        >
          <div
            className="absolute inset-0 bg-[#0B0C10]/80 backdrop-blur-md"
            onClick={onClose}
            data-testid="contact-modal-overlay"
          />
          <motion.div
            className="relative w-full max-w-lg overflow-hidden rounded-3xl border border-white/10 bg-[#12141C]/85 p-8 shadow-[0_24px_80px_rgba(0,0,0,0.6)] backdrop-blur-2xl md:p-10"
            initial={PANEL_INITIAL}
            animate={PANEL_ANIMATE}
            exit={PANEL_EXIT}
            transition={PANEL_TRANSITION}
          >
            <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-[#8B5CF6]/20 blur-[80px]" />
            <button
              data-testid="contact-modal-close"
              onClick={onClose}
              aria-label="Close contact form"
              className="absolute right-5 top-5 flex h-9 w-9 items-center justify-center rounded-full border border-white/10 text-[#F4F6FB]/60 transition-colors duration-300 hover:border-[#8B5CF6]/50 hover:text-[#F4F6FB]"
            >
              <X className="h-4 w-4" />
            </button>
            <p className="font-mono text-[11px] uppercase tracking-[0.45em] text-[#06B6D4]">Contact</p>
            <h3 className="font-display mt-4 text-2xl font-bold text-[#F4F6FB] md:text-3xl">
              Start a conversation.
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-[#F4F6FB]/50">
              Tell us about your world — every message lands directly in the Elentara studio inbox.
            </p>
            <ContactForm onSent={onClose} />
            <p className="mt-6 text-center font-mono text-[10px] uppercase tracking-[0.25em] text-[#F4F6FB]/35">
              Prefer direct email?{" "}
              <a
                data-testid="contact-direct-email-link"
                href="mailto:workelentara@gmail.com"
                className="text-[#06B6D4] transition-colors duration-300 hover:text-[#F4F6FB]"
              >
                workelentara@gmail.com
              </a>
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
